<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.imageryResults', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body p-0">
                <b-form  @reset="onReset" v-if="show">
                    <div class="form-group col-md-12">
                        <span class="obligatoire">*</span>
                        <label for="etablissement_id">{{ $t('message.nomEtablissement') }}</label>
                        <autocomplete
                            :search="getEtablisssements"
                            placeholder="Rechercher l'établissement"
                            aria-label="Rechercher l'établissement"
                            :get-result-value="getValueEtablissement"
                            @submit="chooseEtablissement"
                        ></autocomplete>
                        <input type="hidden" name="etablissement_id" id="etablissement_id" v-model="$v.form.etablissement_id.$model" class="form-control" v-validate="'required'" :class="errors.has('etablissement_id') ? 'is-invalid' : ''"/>
                        <small id="emailHelp" class="form-text text-danger" v-if="$v.form.etablissement_id.$error">Rassurez-vous d'avoir sélectionné l'établissement</small> 
                    </div>
                    <b-row class="p-0">
                        <b-col sm="12">
                            <span class="obligatoire">*</span>
                            <b-form-group id="activity-group" :label="$t('message.activity')" label-for="activity">
                                <multiselect v-model="$v.form.activity_id.$model" :options="missions" :multiple="true" :close-on-select="true" :clear-on-select="false" :preserve-search="true" :placeholder="$t('message.activities')" label="description_fr" track-by="id"></multiselect>
                                <b-form-invalid-feedback v-if="$v.form.activity_id.$error">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>
                                <span v-if="errorshasField('activity_id')" style="color:red">
                                    {{getErrorsField('activity_id')}}
                                </span>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12">
                            <span  class="obligatoire">*</span>
                            <b-form-group
                                id="patient-group"
                                :label="$tc('message.praticien',1)"
                                label-for="patient">
                                <select id="praticien" v-model="$v.form.praticien.$model"
                                    @change="clearErrorField('praticien')" required>
                                    <option data-placeholder="true"></option>
                                    <option v-for="item in mPractitioners" :key="item.id" :value="item.id">
                                        {{ item.nom }}
                                    </option>
                                </select> 
                                <b-form-invalid-feedback>
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <span v-if="errorshasField('praticien')" style="color:red">
                                    {{getErrorsField('praticien')}}
                                </span>

                            </b-form-group>
                        </b-col>

                        <b-col sm="12">
                            <span  class="obligatoire">*</span>

                            <b-form-group
                                    id="consultation-group"
                                    :label="$t('message.typeResultat')"
                                    label-for="consultation">

                        
                                <b-form-input id="consultation" v-model="$v.form.consultation.$model" type="text" placeholder="Type de Résultat" :state="$v.form.consultation.$dirty ? !(errorshasField('consultation_medecine_generale_id') || $v.form.consultation.$error) : null" required></b-form-input>
                                
                                <b-form-invalid-feedback v-if="$v.form.consultation.$error">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-if="errorshasField('consultation_medecine_generale_id')">
                                    {{ getErrorsField('consultation_medecine_generale_id') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>

                        <!-- <b-col sm="12">
                            <span  class="obligatoire">*</span>
                            <b-form-group
                                    id="consultation-group"
                                    :label="$tc('message.generalConsultations', 1)"
                                    label-for="consultation">

                                <select id="consultation"  v-model="$v.form.consultation.$model"
                                        @change="clearErrorField('consultation_medecine_generale_id')"
                                        :state="$v.form.consultation.$dirty ? !(errorshasField('consultation_medecine_generale_id') || $v.form.consultation.$error) : null"
                                        required
                                        class="form-control is-invalid retirerBordure"
                                >
                                    <option data-placeholder="true"></option>
                                    <option v-for="item in mConsultations"  :key="item.value" :value="item.value">
                                        {{ item.text }}
                                    </option>
                                </select>
                                <b-form-invalid-feedback v-if="$v.form.consultation.$error">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-else-if="errorshasField('consultation_medecine_generale_id')">
                                    {{ getErrorsField('consultation_medecine_generale_id') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col> -->

                        <b-col sm="12">
                            <span  class="obligatoire">*</span>
                            <b-form-group
                                    id="description-group"
                                    :label="$t('message.description')"
                                    label-for="description"
                            >
                                <b-form-textarea
                                        id="description"
                                        v-model="$v.form.description.$model"
                                        :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                                        required
                                        @focus="clearErrorField('description')"
                                ></b-form-textarea>

                                <b-form-invalid-feedback v-if="!$v.form.description.required">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>
                                <b-form-invalid-feedback v-if="!$v.form.description.minLength">
                                    {{ $t('message.minCharacters', { n: 3 }) }}
                                </b-form-invalid-feedback>
                                <b-form-invalid-feedback v-else-if="errorshasField('description')">
                                    {{ getErrorsField('description') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>

                        <b-col sm="12">
                            <span  class="obligatoire">*</span>
                            <b-form-group
                                    id="date-group"
                                    :label="$tc('message.dates', 1)"
                                    label-for="date"
                            >
                                <b-form-input
                                        id="date"
                                        v-model="$v.form.date.$model"
                                        :state="$v.form.date.$dirty ? !(errorshasField('date') || $v.form.date.$error) : null"
                                        type="date"
                                        required
                                        @focus="clearErrorField('date')"
                                ></b-form-input>

                                <b-form-invalid-feedback v-if="!$v.form.date.required">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-else-if="errorshasField('date')">
                                    {{ getErrorsField('date') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>

                        <b-col sm="12">
                            <b-form-group
                                    id="upload-group"
                                    :label="$t('message.uploadFile')"
                                    label-for="upload"
                            >
                                <b-form-file
                                        id="upload"
                                        :state="$v.form.file.$dirty ? !$v.form.file.$error : null"
                                        :placeholder="$t('message.maxFileSize')"
                                        :file-name-formatter="formatNames"
                                        @change="setImage"
                                ></b-form-file>

                                <b-form-invalid-feedback>
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>
                                <span >{{fileSize}} </span> <span v-if="sizeError" style="color: red">{{$t('message.tailleMaximum')}}</span>
                            </b-form-group>
                        </b-col>

<!--                        <b-col sm="12">-->
<!--                            <b-container fluid class="p-4">-->
<!--                                <b-row id="image">-->
<!--                                    <b-col>-->
<!--                                        <b-img-lazy-->
<!--                                                class="img-preview"-->
<!--                                                thumbnail-->
<!--                                                :src="imageSrc(form.file)"-->
<!--                                                fluid-grow-->
<!--                                                alt=""-->
<!--                                        ></b-img-lazy>-->
<!--                                    </b-col>-->
<!--                                </b-row>-->
<!--                            </b-container>-->
<!--                        </b-col>-->
                    </b-row>

                    <b-row class="justify-content-center" v-if="can">
                        <b-button @click="onSubmit" variant="primary">
                            {{ $t('message.save') }}
                        </b-button>

                        <!--                        <b-button type="reset" variant="danger">-->
                        <!--                            {{ $t('message.reset') }}-->
                        <!--                        </b-button>-->
                    </b-row>
                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required, minLength } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';
    import Multiselect from 'vue-multiselect';
    import axios from "axios";
    import AppConfig from "../../../constants/AppConfig";
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import '@trevoreyre/autocomplete-vue/dist/style.css'
    import i18n from "../../../plugins/i18n";

    export default {
        name: "AddResultat",
        components: {
            Multiselect,
            Autocomplete
        },

        computed: {
            ...mapGetters(["generalConsultations",
                "file",
                "errors",
                "hasAdminRole",
                "hasMedecinControleRole","hasAssistante",
                "hasPraticienRole", "practitioners"]),

            mConsultations: function() {
                let cArray = [];
                if (! _.isUndefined(this.file.consultations_medecine)){
                    _.forEach(this.file.consultations_medecine, function(consultation) {

                        let text = consultation.date_consultation;

                        cArray.push({ text:text, value: consultation.id });
                    });
                }
                return cArray;
            },
            mPractitioners: function() {
                let pArray = [];

                _.forEach(_.orderBy(this.practitioners,['created_at'],['desc']), function(practitioner) {
                    let p = {};
                    // if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) && practitioner.user.isMedicasure == '1'){
                    if((typeof practitioner.user == 'object') && (!_.isNull(practitioner.user)) && ((practitioner.user.isMedicasure == '0' || practitioner.user.isNotice == '1') || (practitioner.user.isMedicasure || practitioner.user.isNotice == '1'))){
                    // console.log('practitioner.user.isMedicasure => ', practitioner.user.nom);
                    let prenom = practitioner.user.prenom != 'null' && !_.isNull(practitioner.user.prenom) ? practitioner.user.prenom : '';
                    prenom =  prenom.toLowerCase();
                    p.nom =  (practitioner.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                    p.id = practitioner.user.id;
                    if (p.nom.length >0){
                        pArray.push(p);
                    }
                    }

                });
                // console.log("pArray ", pArray)
                return pArray;
            },

            mFiles: function() {

                let value = this.file;

                if (typeof value.patient == "object"){
                    let user = value.patient.user;
                    let fullName = ( user.prenom? user.prenom  : '') +" "+ (user.nom).toUpperCase();
                    let info = (fullName.length > 26 ? fullName.substring(0,26) :fullName) + " ( "+ value.numero_dossier + " ) " ;
                    return info;
                }

                return "";
            },

            can: function () {
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            }
        },

        data() {
            return {
                missions: [],
                file_id: this.$route.params.file,
                form: {
                    praticien: null,
                    consultation: null,
                    description: '',
                    date: '',
                    file: '',
                },
                show: true,
                fileSize:'0 Mo',
                sizeError:false,
            }
        },

        methods: {
            getEtablisssements(input){
                return new Promise(resolve => {
                    if (input.length < 2) {
                    return resolve([])
                    }
                    fetch(AppConfig.apiUrl+'/search/etablissements/'+input, {headers: {'Authorization': "Bearer " + localStorage.getItem('ms-token')}})
                    .then(res => res.json())
                    .then(res => {
                        resolve(res.etablissements)
                    }).catch(error => {
                        console.log('error ', error);
                    })
                })
            },
            getValueEtablissement(result) {
                return result.name
            },
            chooseEtablissement(result) {
                this.form.etablissement_id = result.id;
            },
            getGroupeActivites: function () {
                axios
                    .get(AppConfig.apiUrl + "/mission/list")
                    .then((res) => {this.missions = res.data.activites.map((x )=> ({
                        id: x.id,
                        description_fr: x.description_fr
                    }))})
                    .catch((error) => {window.console.log(error)});
            },
            getMedicalFile() {
                let args = {
                    file: this.file_id
                };

                this.$store.dispatch("getMedicalFile", { args });
            },

            formatNames(files) {
                if (!_.isEmpty(files)){
                    this.fileSize  =  this.formatBytes(files[0].size,2);
                }else{
                    this.fileSize = '0 MB';
                }
                return files[0].name
            },

            getPractitioners() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };

            this.$store.dispatch('getPractitioners', { args : args });
            },

            setImage(event) {
                this.form.file = event.target.files[0];
            },

            imageSrc(img) {
                if (img) {
                    return URL.createObjectURL(img);
                }

                return '';
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid && !this.sizeError) {
                    /*let args = {
                        consultation_medecine_generale_id: this.form.consultation,
                        dossier_medical_id: this.form.dossier,
                        reference: this.form.reference,
                        description: this.form.description,
                        file: this.form.file
                    };*/

                    let formData = new FormData();

                    formData.append('consultation_medecine_generale_id', this.form.consultation);
                    formData.append('dossier_medical_id', this.file.id);
                    formData.append('praticien_id', this.form.praticien);
                    formData.append('activity_id', JSON.stringify(this.form.activity_id));
                    formData.append('etablissement_id', this.form.etablissement_id);
                    formData.append('description', this.form.description);
                    formData.append('date', this.form.date);
                    formData.append('file', this.form.file);

                    let successMessage = this.$i18n.t('message.resultCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createImageryResult', { args: formData, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.consultation = '';
                this.form.type = '';
                this.form.description = '';
                this.form.date = '';
                this.form.file = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                if (!_.isUndefined(field)){
                    if (!_.isUndefined(this.errors)){
                        return this.errors.hasOwnProperty(field);
                    }
                    return "";
                }
                return "";
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            },
            formatBytes(bytes, decimals = 2) {
                if (bytes === 0) return '0 Bytes';

                const k = 1024;
                const dm = decimals < 0 ? 0 : decimals;
                const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

                const i = Math.floor(Math.log(bytes) / Math.log(k));

                let size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm))
                let type =  sizes[i] ;

                if (i >=2 && size >= 5){
                    this.sizeError = true;
                }else {
                    this.sizeError = false;
                }
                return size + ' '+type;

            }
        },

        validations: {
            form: {
                activity_id:{
                    required
                },
                etablissement_id:{required},
                praticien: {
                    required
                },
                consultation: {
                    required
                },
                description: {
                    required,
                    minLength: minLength(3)
                },
                date: {
                    required
                },
                file: {
                    // required
                }
            }
        },

        mounted() {
            // Retrieve medical file list
            this.getGroupeActivites();
            this.getMedicalFile();

            this.getPractitioners();

           /*  new SlimSelect({
                select: '#consultation',
                placeholder: 'Date consultation',

            }); */
            new SlimSelect({
                select: '#praticien',
                placeholder: 'Sélectionnez le praticien',

            });
        }
    }
</script>

<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>